// @ts-nocheck
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Sidebar } from "arui-feather/sidebar";
import _ from "lodash";
import moment from "moment-timezone";



import PaginationControl from "components/tools/pagination-control";
import { Breadcrumb, Button, Container, RowWrapper, Textarea } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import BookingsApi from "api/bookings-api";
import UniversityApi from "api/university-api";

import { stringImposition } from "services/common-service";
import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";
import RoomChatPanel from "../chat/panels/RoomChatPanel";
import * as XLSX from "xlsx";
import { BookingStatuses } from "../ui-kit/status-label";

const ResultsPage = () => {
    const { t } = useTranslation();

    useBodyBackground(`white`);
    const bookings = useStorageListener(`bookings`, {});
    const eventsBookings = useStorageListener(`events-requests`, {});
    const dormitories = useStorageListener(`dormitories`, []);
    const universities = useStorageListener(`universities`, {});

    const [selectedBookingId, setSelectedBookingId] = useState(undefined);
    const [uniComment, setUniComment] = useState("");
    const [selectedChatId, setSelectedChatId] = useState(undefined);

    let allBookings = {...bookings, ...eventsBookings};


    const selectedChatBooking = (selectedChatId == undefined) ? undefined : allBookings[selectedChatId];
    console.log('render: allBookings = ', allBookings);
    console.log('render: selectedChatBooking = ', selectedChatBooking);
    let selectedChatDormitoryId = selectedChatBooking?.dormitoryId;
    console.log('render: selectedChatDormitoryId = ', selectedChatDormitoryId);
    let selectedChatDormitory = (selectedChatDormitoryId == undefined) ? undefined : dormitories[selectedChatDormitoryId];
    let selectedChatUni = (selectedChatDormitory == undefined) ? undefined : universities[selectedChatDormitory?.universityId];
    console.log('selectedChatDormitory = ', selectedChatDormitory);
    let selectedChatDormitoryCommittee = selectedChatDormitory?.details?.rules?.committee;
    console.log('selectedChatDormitoryCommittee = ', selectedChatDormitoryCommittee);
    console.log('selectedChatUni = ', selectedChatUni);

    const filters = useStorageListener((state) => _.get(state, `tables.requests.filters`) ?? {});
    const filterRows = (rows = []) => {
        return rows?.filter?.((i) => {
            return (
                Object.keys(_.pickBy(filters, _.identity)).length === 0 ||
                Object.entries(_.pickBy(filters, _.identity))
                    ?.map?.(([key, value], index) => !value || stringImposition(_.get(i, key), value))
                    ?.reduce?.((a, b) => a && b, true)
            );
        });
    };

    const paginationResult = usePagination(
        filterRows(
            _.values(bookings).sort((a, b) => {
                return (+b.timestamp - +a.timestamp)
            }).map((i) => ({
                ...i,
                quantity: (i.quantity != undefined && +i.quantity >= 5 ? `${i.quantity} ⚠️` : `${i.quantity}`),
                creationDateString: moment(i.timestamp).format('DD.MM.YYYY HH:mm:ss'),
                xNum: `${Math.floor((i.timestamp - 1640995200000) / 1000.0)}`.padStart(9, '0'),
                where: _.get(dormitories, `${_.get(i, `dormitoryId`)}.details.main-info.name`)
            })) as any
        ),
        { perPage: 10 }
    );
    const { visibleItems } = paginationResult;

    // @ts-ignore
    useEffect(BookingsApi.getMyBookings, []);
    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);

    const selectedBooking = selectedBookingId == undefined ? undefined : _.values(bookings).filter((x) => x.id == selectedBookingId)[0];

    let sortedVisibleItems = visibleItems.sort((a, b) => {
        return (+b.timestamp - +a.timestamp)
    });

    return (
        <Container extra={`align-items: flex-start;`} className={"requests_page"}>
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("dwvtcnksbf9")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <RowWrapper extra={`h1 { margin: 0; };`}>
                <h1>{t("gfeigcv5lpp")}</h1>
                <div>
                    <span style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => {
                        const wb = XLSX.utils.book_new();
                        const ws = XLSX.utils.aoa_to_sheet([]);

                        XLSX.utils.sheet_add_aoa(ws, [["ФИО", "Дата въезда", "Дата выезда", "Кол-во мест", "Телефон", "Email", "Статус"]]);

                        let bookingsArr = Object.values(bookings);

                        bookingsArr.forEach(booking => {
                            XLSX.utils.sheet_add_aoa(ws, [[
                                _.get(booking, `author.name`),
                                moment(_.get(booking, `dates.from`)).format(`DD.MM.YYYY`),
                                moment(_.get(booking, `dates.to`)).format(`DD.MM.YYYY`),
                                _.get(booking, `quantity`),
                                _.get(booking, `author.contacts.phone`),
                                _.get(booking, `author.contacts.email`),
                                BookingStatuses[booking.status]
                            ]], { origin: -1 });
                        });

                        // Adding the worksheet to the workbook
                        XLSX.utils.book_append_sheet(wb, ws, "Report");

                        // Generate a CSV file and trigger download
                        XLSX.writeFile(wb, "export.xlsx");
                    }}>
                        выгрузить
                    </span>
                </div>
            </RowWrapper>
            <Table
                name="requests"
                withPagination={false}
                useBackendProcessing={false}
                columns={[
                    { name: `xNum`, label: `Номер`, extra: `flex: 1.5;` },
                    { name: `creationDateString`, label: `Дата подачи`, extra: `flex: 1.5;` },
                    { name: `author.name`, label: `Кто`, extra: `flex: 3;` },
                    {
                        name: `date`,
                        label: `Период бронирования`,
                        extra: `flex: 2;`,
                        transform: ({ row }) =>
                            `${moment(_.get(row, `dates.from`)).format(`DD.MM.YYYY`)} - ${moment(_.get(row, `dates.to`)).format(`DD.MM.YYYY`)}`
                    },
                    {
                        name: `status`,
                        label: `Статус`,
                        cell: {
                            type: `statusLabel`,
                            onChange: (x) => {
                                console.log("onChange: x = ", x);
                                BookingsApi.updateBooking(x);
                                setSelectedBookingId(x?.id);
                            }
                        },
                        extra: `flex: 1.5; justify-content: center;`,
                        transform: (d) => d.value,
                        sortable: false
                    },
                    { name: `where`, label: `Где`, extra: `flex: 3;` },
                    {
                        name: `chat`, label: `Чат`, extra: `flex: 3;`,
                        cell: {
                            type: "chat",
                            messagesNumber: 2,
                            // transform: (d) => d,
                            onClick: a => {
                                console.log('onClick: a = ', a);
                                // window.alert('a.id ' + a.id);
                                setSelectedChatId(a.id);
                            }
                        }
                    },
                    { name: `quantity`, label: `Количество`, extra: `flex: 1; justify-content: center;` },
                    {
                        name: `requestsMoreButton`,
                        label: ``,
                        extra: `width: 30px; flex: unset;`,
                        cell: {
                            type: `menu`,
                            options: [
                                {
                                    label: `Редактировать`,
                                    onClick: ({ row, navigate }) => navigate(`/edit-booking/${row.id}`)
                                },
                                {
                                    label: `Полная информация`,
                                    onClick: ({ row, navigate }) => navigate(`/preview-booking/${row.id}`)
                                },
                                {
                                    label: `Удалить бронь`,
                                    extra: ({ theme }) => `color: ${theme.red};`,
                                    onClick: ({ row }) => {
                                        ModalsService.showModality({
                                            title: `Удаление бронирования`,
                                            description: `Вы уверены, что хотите удалить это бронирование?`,
                                            cancelButton: {
                                                children: `Отмена`,
                                                background: `gray`
                                            },
                                            confirmButton: {
                                                children: `Удалить`,
                                                background: `red`,
                                                onClick: async () => await BookingsApi.deleteBooking(row?.id)
                                            }
                                        });
                                    }
                                },
                                {
                                    label: `Комментарий`,
                                    extra: ({ theme }) => `color: ${theme.blue};`,
                                    onClick: ({ row }) => {
                                        setSelectedBookingId(row?.id);
                                        let selBooking = row?.id == undefined ? undefined : _.values(bookings).filter((x) => x.id == row?.id)[0];
                                        let selComment = selBooking?.uniComment || "";
                                        setUniComment(selComment);
                                    }
                                }
                            ]
                        }
                    }
                ]}
                rows={sortedVisibleItems}
                extra={`margin-top: 56px;`}
            />
            <PaginationControl pagination={paginationResult} />

            <Sidebar
                visible={selectedBooking != undefined}
                onCloserClick={() => {
                    setSelectedBookingId(undefined);
                }}
            >
                {selectedBooking == undefined ? null : (
                    <>
                        <h3>{t("yoqcch3984")}</h3>

                        <div style={{ height: "40vh", marginBottom: 10 }}>
                            <Textarea
                                autoFocus={true}
                                value={uniComment}
                                onChange={(evt) => {
                                    setUniComment(evt.target.value);
                                }}
                            />
                        </div>

                        <div>
                            <Button
                                onClick={async () => {
                                    await BookingsApi.updateBooking({
                                        id: selectedBooking?.id, ...selectedBooking,
                                        uniComment: uniComment
                                    });
                                    setSelectedBookingId(undefined);
                                }}
                            >
                                {t("tykgvkx6d2")}
                            </Button>
                        </div>
                    </>
                )}
            </Sidebar>

            <Sidebar visible={(selectedChatId != undefined)} onCloserClick={() => {
                setSelectedChatId(undefined);
            }}>

                {selectedChatId == undefined ? null :
                    <div>
                        {/*<h2 style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}} >*/}
                        {/*    <span>*/}
                        {/*        Чат*/}
                        {/*    </span>*/}
                        {/*</h2>*/}
                        {/*{selectedChatDormitoryCommittee == undefined ? null :*/}
                        {/*    <div style={{fontSize: '12px'}} >*/}

                        {/*        <b>{selectedChatUni?.details?.name}</b>*/}
                        {/*        <br/>*/}

                        {/*        {selectedChatDormitoryCommittee.name}*/}
                        {/*        <br/>*/}

                        {/*        {`${selectedChatDormitoryCommittee.phone} , ${selectedChatDormitoryCommittee.email}`}*/}
                        {/*    </div>*/}
                        {/*}*/}
                        <div style={{ height: "calc(100vh - 200px)", maxHeight: `calc(100vh - 200px)`, overflowY: "hidden", marginTop: '15px' }}>
                            <RoomChatPanel
                                status={selectedChatBooking?.status}
                                roomId={selectedChatId} />
                        </div>
                    </div>
                }

            </Sidebar>

        </Container>
    );
};

export default ResultsPage;
